import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { JsonApiDecorator } from '../json-api/JsonApiDecorator.js';
import { buildGenericProps } from './buildGenericProps.js';
import { connect } from 'react-redux';

var connectGenericProps = function connectGenericProps(config) {
  var mapGenericProps = function mapGenericProps(state, ownProps) {
    var _config2;

    if (typeof config === 'function') {
      config = config(ownProps);
    }

    var _config = config,
        entity = _config.entity,
        includes = _config.includes,
        selectMember = _config.selectMember,
        _config$metaEntities = _config.metaEntities,
        metaEntities = _config$metaEntities === void 0 ? [] : _config$metaEntities;
    var pickedProps = {};
    var allIncludes;

    if ((_config2 = config) !== null && _config2 !== void 0 && _config2.pickContainerProps) {
      var _config3;

      pickedProps = (_config3 = config) === null || _config3 === void 0 ? void 0 : _config3.pickContainerProps(ownProps);
    }

    if (state.api.currentEntityId && selectMember !== null && selectMember !== void 0 && selectMember.selectIncludes) {
      allIncludes = _toConsumableArray(new Set(includes.concat(selectMember.selectIncludes)));
    }

    var genericProps = buildGenericProps(state, entity, allIncludes || includes, metaEntities);
    var apiStore = new JsonApiDecorator(state.api);
    var bundleStore = state[config.bundleReducer];
    var route = ownProps.route,
        params = ownProps.params,
        router = ownProps.router,
        location = ownProps.location,
        routeParams = ownProps.routeParams,
        match = ownProps.match;

    var props = _objectSpread2(_objectSpread2(_objectSpread2({}, genericProps), pickedProps), {}, {
      config: config,
      apiStore: apiStore,
      route: route,
      router: router,
      params: params,
      location: location,
      routeParams: routeParams,
      match: match
    }, bundleStore);

    var stateProps = typeof config.mapStateToProps === 'function' ? config.mapStateToProps(state, props) : {};
    return _objectSpread2(_objectSpread2({}, props), stateProps);
  };

  return connect(mapGenericProps);
};

export { connectGenericProps };